import * as React from 'react';

function SvgIconPaymentStripe(props) {
  return (
    <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#EAECF4" cx={28} cy={28} r={28} />
        <path
          d="M48 28.77c0-2.9-1.38-5.19-4.01-5.19-2.65 0-4.25 2.3-4.25 5.17 0 3.41 1.9 5.13 4.6 5.13a6.1 6.1 0 003.08-.73v-2.27a5.8 5.8 0 01-2.72.62c-1.08 0-2.03-.38-2.16-1.72h5.44l.02-1zm-5.49-1.07c0-1.29.77-1.82 1.47-1.82.68 0 1.4.53 1.4 1.82H42.5zm-7.05-4.12a3.1 3.1 0 00-2.18.89l-.15-.7H30.7v13.2l2.78-.6v-3.2c.4.3 1 .71 1.97.71 2 0 3.8-1.63 3.8-5.22 0-3.29-1.84-5.08-3.78-5.08zm-.67 7.81c-.66 0-1.05-.24-1.31-.53l-.01-4.2a1.6 1.6 0 011.32-.56c1.01 0 1.71 1.15 1.71 2.64 0 1.52-.69 2.65-1.71 2.65zm-7.92-8.48l2.79-.6V20l-2.8.6zm0 .86h2.79v9.92h-2.79zm-2.99.84l-.18-.84h-2.4v9.92h2.78v-6.72c.65-.87 1.76-.71 2.1-.59v-2.6c-.35-.14-1.65-.4-2.3.83zm-5.56-3.3l-2.7.6-.02 9.07a2.82 2.82 0 002.88 2.91c.9 0 1.58-.17 1.94-.37v-2.3c-.35.15-2.1.67-2.1-1v-4.03h2.1v-2.42h-2.1v-2.46zm-7.51 5.34c0-.44.36-.6.95-.6.84 0 1.9.25 2.75.72V24.1a7.2 7.2 0 00-2.75-.52c-2.26 0-3.76 1.2-3.76 3.2 0 3.14 4.22 2.64 4.22 3.99 0 .52-.44.69-1.06.69-.93 0-2.1-.39-3.04-.9v2.69c1.04.45 2.08.64 3.04.64 2.3 0 3.9-1.16 3.9-3.2-.02-3.37-4.25-2.77-4.25-4.04z"
          fill="#6772E5"
        />
      </g>
    </svg>
  );
}

export default SvgIconPaymentStripe;
